import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import store from './store'
import router from './router'
import VueCookies from 'vue-cookies'

import Axios from './axios'
import VuePlyr from 'vue-plyr'
Vue.use(VueCookies)
Vue.use(VuePlyr, {
  plyr: {
    fullscreen: { enabled: false }
  },
  emit: ['ended']
})
Vue.prototype.$http = Axios
Vue.config.productionTip = false
// 開発時のみtrueに変更
// Vue.config.devtools = false

export const eventBus = new Vue()

router.beforeEach((to, from, next) => {
  if (to.path == "/login") {
    store.dispatch("logininfo/logout");
    store.dispatch("individual/STATE_INIT");
    store.dispatch("domain/STATE_INIT");
  }
  const loggingIn = store.getters['logininfo/isLoggingIn'];
  if (to.matched.some(page => page.meta.isPublic) || loggingIn) {
    next();
  } else {
    next('/login');
    // next();
  }
});

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
